module.exports = __webpack_public_path__ + "media/images/modal/Pop-Up_SCV-ee27ebea74bb383f2cea9617bc9272fc.png";